import { render, staticRenderFns } from "./payReceivable.vue?vue&type=template&id=2981ce78&scoped=true&"
import script from "./payReceivable.vue?vue&type=script&lang=js&"
export * from "./payReceivable.vue?vue&type=script&lang=js&"
import style0 from "./payReceivable.vue?vue&type=style&index=0&id=2981ce78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981ce78",
  null
  
)

export default component.exports